import { render } from "./PayrollDdExport.vue?vue&type=template&id=4e0e649c&scoped=true"
import script from "./PayrollDdExport.vue?vue&type=script&lang=js"
export * from "./PayrollDdExport.vue?vue&type=script&lang=js"

import "./PayrollDdExport.vue?vue&type=style&index=0&id=4e0e649c&scoped=true&lang=css"
import "./PayrollDdExport.vue?vue&type=style&index=1&id=4e0e649c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0e649c"]])

export default __exports__